<mat-progress-bar
  class="progress-bar"
  color="primary"
  mode="indeterminate"
  [ngStyle]="{ visibility: loading ? 'visible' : 'hidden' }"
/>
@if (loading) {
  <div class="progress-bar-backdrop"></div>
}
